// Utilities
import { propsFactory } from "../util/index.mjs"; // Types
// Composables
export const makeTagProps = propsFactory({
  tag: {
    type: String,
    default: 'div'
  }
}, 'tag');
//# sourceMappingURL=tag.mjs.map